// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import {
    CalendarPlanBlockClientData,
    CalendarPlanActivityClientData,
    LessonAdditionalInfo,
    ActualContentBlockClientData,
} from '@yandex-int/k-common/typings/api/models/main-page';

import {
    ContentShowcaseWidgetData,
    ContentShowcaseWidgetInnerItemData,
    ContentShowcaseWidgetItemData,
} from 'common.components/widgets.content-showcase/typings';

export function getActivityColor(activity: CalendarPlanActivityClientData) {
    return activity?.activity_view_settings?.visual_settings?.bg_color || null;
}

export function getBgColors(block: CalendarPlanBlockClientData) {
    const { activities, visual_settings: visualSettings } = block;
    const { background_img_colors: bgColors } = visualSettings || {};
    const lessonWithIllustration = activities.find((i) =>
        Boolean((i.content_additional_info as LessonAdditionalInfo | undefined)?.lesson_view_settings)
    );
    let lessonBgColors =
        (lessonWithIllustration?.content_additional_info as LessonAdditionalInfo | undefined)?.lesson_view_settings
            ?.gradient_colors?.colors || [];
    lessonBgColors = lessonBgColors.filter(Boolean);

    const result: (string | null)[] = [];

    if (lessonBgColors) {
        result.push(...lessonBgColors);
    }

    if (activities[0]) {
        result.push(getActivityColor(activities[0]));
    }

    if (activities[1]) {
        result.push(getActivityColor(activities[1]));
    }

    if (bgColors) {
        result.push(...bgColors);
    }

    return result;
}

export interface ActualContentWidgetItemData extends ContentShowcaseWidgetItemData {
    slug: SUBJECTS_SLUGS;
}

export function getWidgetDataFromActualContentWidgetBlock(
    block: ActualContentBlockClientData
): ContentShowcaseWidgetData {
    const { title: blockTitle, additional_info: additionalInfo } = block;

    const { subjects: blockItems } = additionalInfo;

    const widgetItems: ContentShowcaseWidgetItemData[] = blockItems.map((blockItem) => {
        const { activities: blockItemInnerItems } = blockItem;

        const widgetItemInnerItems: ContentShowcaseWidgetInnerItemData[] = blockItemInnerItems.map(
            (blockItemInnerItem) => {
                return {
                    icon: blockItemInnerItem.activity_view_settings?.icon,
                };
            }
        );

        const lessonWithIllustration = blockItemInnerItems.find((i) =>
            Boolean((i.content_additional_info as LessonAdditionalInfo | undefined)?.lesson_view_settings)
        );

        const {
            image: lessonImgSrc,
            gradient_colors: gradientColors,
            background: lessonBgColor,
        } = (lessonWithIllustration?.content_additional_info as LessonAdditionalInfo | undefined)
            ?.lesson_view_settings || {};

        const shouldUseImageAsBackground = Boolean(
            lessonImgSrc && !(gradientColors?.colors || []).filter(Boolean).length
        );

        return {
            name: blockItem.name,
            description: blockItem.theme?.description,
            originalData: blockItem,
            visualSettings: {
                colors: getBgColors(blockItem),
                image: lessonImgSrc,
                backgroundColor: lessonBgColor,
                backgroundImage: shouldUseImageAsBackground ? lessonImgSrc : undefined,
            },
            items: widgetItemInnerItems,
            slug: blockItem.slug,
        };
    });

    return {
        title: blockTitle,
        items: widgetItems,
    };
}
